import { Field } from "@progress/kendo-react-form";

import {
  FormAutoComplete,
  FormComboBox,
  FormInput,
  FormSwitch,
} from "./form-components";

import {
  emailValidator,
  nameValidator,
  requiredValidator,
} from "./validators";
import { roles, states, statesWithAM } from "./data";
import { CustomerProps } from "../interface/DeliveryProps";

export const CustomerDetails = ({deliveryNotification, onToggleNotification}: CustomerProps) => {
  return (
    <div>
      <h6><strong>Requestor Details</strong></h6>
      <div className="row">
        <div className="col">
          <Field
            key={"firstName"}
            id={"firstName"}
            name={"firstName"}
            label={"First Name"}
            component={FormInput}
            validator={nameValidator}
          />
        </div>
        <div className="col">
          <Field
            key={"lastName"}
            id={"lastName"}
            name={"lastName"}
            label={"Last Name"}
            component={FormInput}
            validator={nameValidator}
          />
        </div>
      </div>
      <Field
        key={"role"}
        id={"roleselected"}
        name={"roleselected"}
        label={"Role"}
        component={FormComboBox}
        data={roles}
        validator={requiredValidator}
      />
      <Field
        key={"organisation"}
        id={"organisation"}
        name={"organisation"}
        label={"Organisation"}
        component={FormInput}
        validator={requiredValidator}
      />
      <Field
        key={"state"}
        id={"state"}
        name={"state"}
        label={"State"}
        component={FormComboBox}
        data={statesWithAM}
        validator={requiredValidator}
      />
      <Field
        key={"email"}
        id={"email"}
        name={"email"}
        label={"Email"}
        component={FormInput}
        validator={emailValidator}
      />
      <Field
        key={"reqnotification"}
        id={"reqnotification"}
        name={"reqnotification"}
        label={"Notify with tracking details"}
        component={FormSwitch}
        onChange={onToggleNotification}
        checked={deliveryNotification}
      />
      <br></br>      
    </div>
  );
};
